import NormalGameManager from "../manager/NormalGameManager";
import normalMode from "../normalMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TimeNode extends cc.Component {
    protected update(dt: number): void {
        this.node.getChildByName("lb_day").getComponent(cc.Label).string = `第${Math.floor(NormalGameManager._instance.mGameHours / 24) + 1 }天`;
        // this.node.getChildByName("lb_time").getComponent(cc.Label).string = this.getNumToCountNum(Math.floor(this.normal.gameManager.mGameHours % 24),2) + ":" + this.getNumToCountNum( Math.floor((this.normal.gameManager.mGameHours - Math.floor(this.normal.gameManager.mGameHours)) * 60),2);
        this.node.getChildByName("lb_time").getComponent(cc.Label).string = this.getNumToCountNum(Math.floor(NormalGameManager._instance.mGameHours % 24),2) + ":" + this.getNumToCountNum( Math.floor(NormalGameManager._instance.mMinute) ,2);
    }

    getNumToCountNum(num:number,count:number){
        let s = num.toString();
        if(s.length<count){
            let needCount:number = count - s.length;
            for(let i = 0;i<needCount;i++){
                s = "0" + s;
            }
        }
        return s;
    }

}
